'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
export function PostHogProvider({
  children
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST
    });
  }, []);
  return <PHProvider client={posthog} data-sentry-element="PHProvider" data-sentry-component="PostHogProvider" data-sentry-source-file="PostHogProvider.tsx">{children}</PHProvider>;
}